import React from 'react';

const LocalOfferIcon = ({ width = 24, height = 24, fill = '#656263', className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.415 0.589844L21.415 11.5798L11.575 21.4098L0.584961 10.4198V0.589844H10.415ZM2.58496 4.08984C2.58496 4.91984 3.25496 5.58984 4.08496 5.58984C4.91496 5.58984 5.58496 4.91984 5.58496 4.08984C5.58496 3.25984 4.91496 2.58984 4.08496 2.58984C3.25496 2.58984 2.58496 3.25984 2.58496 4.08984Z"
        fill={fill}
      />
    </svg>
  );
};

export default LocalOfferIcon;
